export default __webpack_public_path__ + "static/media/indexxPaypalForDarkMode.59eeefa9.svg";